import type { ComponentSchema } from '../../../../../schema-types'
import { schema as shared } from '../../../../lightings/lightings-1/sections/product/product-detail.schema'

/** Fresh Basket product page: the shared fields plus a "How to order" tab and the delivery areas table. */
export const schema: ComponentSchema = {
  ...shared,
  commonFields: [
    ...shared.commonFields,
    { key: 'howToOrderTitle', label: '"How to order" tab title', type: 'string', default: 'How to order' },
    { key: 'howToOrder', label: 'How to order', type: 'localized-text', help: 'Steps shown in their own tab; the tab is hidden while this is empty.' },
    { key: 'showDeliveryAreas', label: 'Show delivery areas and charges', type: 'boolean', default: true },
  ],
}
